import { FileCheck, Users, Building, ArrowRight, UserCheck, Settings, Award } from "lucide-react"
import { Button } from "../../components/ui/button"

// Staff Imports - Explicitly imported to avoid duplicates and control presentation
import anita from "../../assets/Staff Member/Anita COYITUNGIYE_Chef de Service de la Scolarité et des Enseignement.jpg"
import armand from "../../assets/Staff Member/Armand MFURA_Doyen des Sciences et Technologie.jpg"
import ascension from "../../assets/Staff Member/Ascension Diniragora_Chef de Departement d'Agribusiness à la FSAV.jpg"
import augustin from "../../assets/Staff Member/Augustin NIKOBASA_Statisticien de l'UNG.jpg"
import longin from "../../assets/Staff Member/BARANYIZIGIYE Longin_Responsable du CERADER.jpg"
import patriceB from "../../assets/Staff Member/BIGIRIMANA Patrice_Laborantin au Laboratoire de Microbiologie.jpg"
import denis from "../../assets/Staff Member/BIZIMANA Denis Bosco_Chargé des Affaires Sociales.jpg"
import constantin from "../../assets/Staff Member/Constantin NDIKUMANA_Secrétaire des Masters de la Faculté de Droit, des Sciences Economiques et de Gestion.jpg"
import cerenie from "../../assets/Staff Member/Cérénie IRAKOZE_Service Financier, Caissière.jpg"
import lambert from "../../assets/Staff Member/Doctorant Lambert NDIKUMANA_Chef de Département de Droit et des Sciences économiques.jpg"
import consolate from "../../assets/Staff Member/Dr Consolate NSABIMANA_Doyen de la Faculté des Sciences Agronomiques et Vétérinaires.jpg"
import simeon from "../../assets/Staff Member/Dr Siméon NYANDWI_Doyen de la Faculté de Droit, des Sciences Economiques et de Gestion.jpg"
import beatrice from "../../assets/Staff Member/Dr Soeur Béatrice NTAKAMURENGA_Directeur de Recherche et Innovation.jpg"
import benigne from "../../assets/Staff Member/Dr Soeur Bénigne NGENDAKUMANA_Directeur d'Assurance Qualité.jpg"
import fulgence from "../../assets/Staff Member/Fulgence TWIZERIMANA_Coordinateur de l'American Corner Ngozi.jpg"
import libere from "../../assets/Staff Member/NDAYISENGA Libère_Directeur Administratif, Financier et du Patrimoine.jpg"
import flora from "../../assets/Staff Member/NIYERA Flora_FDSEG, Chef de département des Sciences de Gestion.jpg"
import ildephonse from "../../assets/Staff Member/NKURUNZIZA Ildephonse_Secrétaire Académique.jpg"
import oscar from "../../assets/Staff Member/OScar MANIRAKIZA_Secrétaire des Masters de la Faculté des Sciences Agronomiques et Véterinaires.jpg"
import patriceN from "../../assets/Staff Member/Patrice NDAYIZEYE_Technicien de Maintenance.jpg"
import jeanneS from "../../assets/Staff Member/SURWAVUBA Jeanne_Service Financier, Comptable.jpg"
import athanasie from "../../assets/Staff Member/Soeur NIZIGIYIMANA Athanasie_Directeur de Cabinet du Recteur.jpg"
import jeanneN from "../../assets/Staff Member/Soeur NTAHOMBAYE Jeanne D'Arc_Chef Financier.jpg"
import mediatrice from "../../assets/Staff Member/UWIMANA Médiatrice_Chef de Service Ressources Humaines et Patrimoine.jpg"
import venuste from "../../assets/Staff Member/Vénuste NDAYIYUNGEKO_Coordinateur de l'Ideas Box et Secrétaire de l'ISCOBA.jpg"

// Bujumbura Campus Staff Imports
import esperance from "../../assets/Staff Member/Sr Espérance BEDETSE; Chef de Département des Sciences de la Santé Bujumbura.jpeg"
import gordien from "../../assets/Staff Member/NTIRAMPEBA Gordien Responsable à la maintenance informatique et électricité Bujumbura.jpeg"
import jeanine from "../../assets/Staff Member/Jeanine Nzeyimana Secrétaire Comptable Campus Winterekwa Bujumbura.jpeg"
import methode from "../../assets/Staff Member/Kwizera Méthode Directeur de l'ISCOBA Bujumbura.jpeg"
import philippeK from "../../assets/Staff Member/Dr Philippe Kanyabweru Doyen de la Faculté de Médecine et des Sciences de la Sante Bujumbura.jpeg"

import teamViceRecteur from "../../assets/team/v-recteur.jpg"

const staffCategories = [
    {
        id: "direction",
        title: "Le pilotage stratégique et administratif de l'institution.",
        description: "",
        members: [
            { src: athanasie, name: "Soeur NIZIGIYIMANA Athanasie", status: "Directeur de Cabinet du Recteur" },
            { src: teamViceRecteur, name: "Abbé Lambert RIYAZIMANA", status: "Directeur Académique" },
            { src: beatrice, name: "Dr Soeur Béatrice NTAKAMURENGA", status: "Directeur de Recherche et Innovation" },
            { src: benigne, name: "Dr Soeur Bénigne NGENDAKUMANA", status: "Directeur d'Assurance Qualité" },
            { src: libere, name: "NDAYISENGA Libère", status: "Directeur Administratif, Financier et du Patrimoine" },
            { src: ildephonse, name: "NKURUNZIZA Ildephonse", status: "Secrétaire Académique" },
            { src: jeanneN, name: "Soeur NTAHOMBAYE Jeanne D'Arc", status: "Chef Financier" },
            { src: mediatrice, name: "UWIMANA Médiatrice", status: "Chef de Service Ressources Humaines et Patrimoine" },
            { src: anita, name: "Anita COYITUNGIYE", status: "Chef de Service de la Scolarité et des Enseignement" }
        ]
    },
    {
        id: "facultes",
        title: "Facultés & Départements",
        description: "L'excellence académique au cœur de nos facultés.",
        members: [
            { src: armand, name: "Armand MFURA", status: "Doyen des Sciences et Technologie" },
            { src: consolate, name: "Dr Consolate NSABIMANA", status: "Doyen de la Faculté des Sciences Agronomiques et Vétérinaires" },
            { src: simeon, name: "Dr Siméon NYANDWI", status: "Doyen de la Faculté de Droit, des Sciences Economiques et de Gestion" },
            { src: philippeK, name: "Dr Philippe Kanyabweru", status: "Doyen de la Faculté de Médecine et des Sciences de la Santé (Bujumbura)" },
            { src: methode, name: "Kwizera Méthode", status: "Directeur de l'ISCOBA (Bujumbura)" },
            { src: flora, name: "NIYERA Flora", status: "FDSEG, Chef de département des Sciences de Gestion" },
            { src: lambert, name: "Doctorant Lambert NDIKUMANA", status: "Chef de Département de Droit et des Sciences économiques" },
            { src: ascension, name: "Ascension Diniragora", status: "Chef de Departement d'Agribusiness à la FSAV" },
            { src: esperance, name: "Sr Espérance BEDETSE", status: "Chef de Département des Sciences de la Santé (Bujumbura)" }
        ]
    },
    {
        id: "administration",
        title: "Administration & Coordination",
        description: "Coordination des services et projets transversaux.",
        members: [
            { src: longin, name: "BARANYIZIGIYE Longin", status: "Responsable du CERADER" },
            { src: fulgence, name: "Fulgence TWIZERIMANA", status: "Coordinateur de l'American Corner Ngozi" },
            { src: venuste, name: "Vénuste NDAYIYUNGEKO", status: "Coordinateur de l'Ideas Box et Secrétaire de l'ISCOBA" },
            { src: denis, name: "BIZIMANA Denis Bosco", status: "Chargé des Affaires Sociales" }
        ]
    },
    {
        id: "support",
        title: "Support Académique & Technique",
        description: "L'appui indispensable au bon fonctionnement quotidien.",
        members: [
            { src: constantin, name: "Constantin NDIKUMANA", status: "Secrétaire des Masters de la Faculté de Droit, des Sciences Economiques et de Gestion" },
            { src: oscar, name: "OScar MANIRAKIZA", status: "Secrétaire des Masters de la Faculté des Sciences Agronomiques et Véterinaires" },
            { src: augustin, name: "Augustin NIKOBASA", status: "Statisticien de l'UNG" },
            { src: cerenie, name: "Cérénie IRAKOZE", status: "Service Financier, Caissière" },
            { src: jeanneS, name: "SURWAVUBA Jeanne", status: "Service Financier, Comptable" },
            { src: jeanine, name: "Jeanine Nzeyimana", status: "Secrétaire Comptable Campus Winterekwa (Bujumbura)" },
            { src: patriceB, name: "BIGIRIMANA Patrice", status: "Laborantin au Laboratoire de Microbiologie" },
            { src: patriceN, name: "Patrice NDAYIZEYE", status: "Technicien de Maintenance" },
            { src: gordien, name: "NTIRAMPEBA Gordien", status: "Responsable à la maintenance informatique et électricité (Bujumbura)" }
        ]
    }
]

export default function General() {
    return (
        <div className="min-h-screen bg-background font-sans text-foreground">
            {/* Hero Section - Standard (ref: DroitEcoGestion) */}
            <header className="relative min-h-[60vh] flex items-center bg-primary overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <div className="absolute inset-0 bg-gradient-to-r from-primary via-primary/80 to-transparent" />
                </div>
                <div className="container relative z-10 py-20">
                    <div className="max-w-3xl">
                        <div className="inline-flex items-center gap-4 mb-8 translate-y-4 animate-in fade-in duration-700 fill-mode-forwards">
                            <span className="text-[10px] uppercase tracking-[0.3em] text-accent font-black">Administration</span>
                            <div className="h-px w-12 bg-accent/50" />
                            <span className="text-[10px] text-primary-foreground/60 uppercase tracking-widest font-bold">Vol. 2024</span>
                        </div>
                        <h1 className="heading-1 mb-8 leading-[0.95] font-serif tracking-tight text-white translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-200">
                            <span className="block italic font-light text-accent/90">Secrétariat</span>
                            <span className="block text-white mt-2">Général</span>
                        </h1>
                        <div className="border-l-4 border-accent pl-8 mb-12 max-w-2xl translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-500">
                            <p className="text-lg md:text-xl font-light leading-relaxed text-primary-foreground/90">
                                Le cœur opérationnel de l'université.
                                <span className="italic block mt-1 tracking-tight">Assurer l'efficacité administrative au quotidien.</span>
                            </p>
                        </div>
                        <div className="flex flex-wrap gap-6 items-center translate-y-4 animate-in fade-in duration-1000 fill-mode-forwards delay-700">
                            <Button className="bg-accent text-accent-foreground px-10 py-7 text-sm font-black transition-all duration-300 border-b-4 border-black/20 rounded-xl">
                                Nous Contacter
                                <ArrowRight className="w-5 h-5 ml-3" />
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce opacity-20">
                    <div className="w-px h-12 bg-white" />
                </div>
            </header>

            {/* Stats Bar */}
            <div className="border-y border-border bg-secondary/10">
                <div className="container py-4 flex flex-wrap items-center gap-8">
                    {[
                        { val: "Académique", label: "Service" },
                        { val: "Logistique", label: "Service" },
                        { val: "Relations", label: "Publiques" },
                        { val: "100%", label: "Support" }
                    ].map((stat, i) => (
                        <div key={i} className="flex items-center gap-3">
                            <span className="text-xl font-black text-primary">{stat.val}</span>
                            <span className="text-[10px] text-muted-foreground uppercase font-black tracking-widest">{stat.label}</span>
                            {i < 3 && <span className="hidden lg:block text-border ml-4 font-light">/</span>}
                        </div>
                    ))}
                </div>
            </div>

            <article className="container section-padding-sm">
                <div className="grid lg:grid-cols-[250px_1fr] gap-12 lg:gap-20">
                    {/* Sidebar */}
                    <aside className="lg:sticky lg:top-8 lg:self-start hidden lg:block">
                        <nav className="space-y-1">
                            <p className="text-[10px] uppercase tracking-[0.2em] font-black text-muted-foreground mb-6 pb-2 border-b border-border">
                                Sommaire
                            </p>
                            {["Services", "Équipe", "Contact"].map((item, i) => (
                                <a key={i} href={`#${item.toLowerCase().replace("é", "e")}`} className="group flex items-start gap-3 py-2 text-xs font-bold text-muted-foreground hover:text-primary transition-smooth">
                                    <span className="text-accent font-black">0{i + 1}</span>
                                    {item}
                                </a>
                            ))}
                        </nav>
                    </aside>

                    {/* Content */}
                    <main className="space-y-16">
                        {/* Section 1: Services */}
                        <section id="services">
                            <h2 className="heading-4 text-foreground mb-8 flex items-center gap-3">
                                <div className="w-1 h-6 bg-accent rounded-full"></div>
                                Services & Départements
                            </h2>
                            <div className="grid md:grid-cols-2 gap-6">
                                {[
                                    {
                                        t: "Service Académique",
                                        d: "Gestion des inscriptions, des dossiers étudiants, des relevés de notes et de la délivrance des diplômes.",
                                        icon: FileCheck
                                    },
                                    {
                                        t: "Logistique & Patrimoine",
                                        d: "Maintenance des infrastructures, gestion des équipements, approvisionnement et sécurité des campus.",
                                        icon: Building
                                    },
                                    {
                                        t: "Relations Publiques",
                                        d: "Communication institutionnelle, accueil, protocole et organisation des événements officiels.",
                                        icon: Users
                                    },
                                    {
                                        t: "Support Administratif",
                                        d: "Coordination des bureaux, archivage et assistance aux différents départements.",
                                        icon: Settings
                                    }
                                ].map((item, i) => (
                                    <div key={i} className="interactive-card p-6 border-l-4 border-primary transition-smooth group hover-lift">
                                        <item.icon className="w-8 h-8 text-primary mb-4 opacity-70 group-hover:opacity-100 transition-opacity" />
                                        <h3 className="heading-4 mb-2 group-hover:text-primary transition-colors">{item.t}</h3>
                                        <p className="text-xs text-muted-foreground leading-relaxed">{item.d}</p>
                                    </div>
                                ))}
                            </div>
                        </section>

                        {/* Section: Staff Team */}
                        <section id="equipe" className="space-y-12">
                            <div className="flex items-center justify-between mb-8">
                                <h2 className="heading-4 text-foreground flex items-center gap-3">
                                    <div className="w-1 h-6 bg-accent rounded-full"></div>
                                    Notre Équipe Administrative
                                </h2>
                            </div>

                            {staffCategories.map((category) => (
                                <div key={category.id} className="space-y-8">
                                    <div className="border-l-2 border-accent/30 pl-6">
                                        <h3 className="heading-4 text-primary mb-1">{category.title}</h3>
                                        <p className="text-xs text-muted-foreground italic font-medium">{category.description}</p>
                                    </div>

                                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                                        {category.members.map((member, i) => (
                                            <div key={i} className="group relative overflow-hidden rounded-3xl bg-secondary/5 aspect-[3/4] hover-lift transition-all duration-700 shadow-sm hover:shadow-2xl">
                                                {/* Image */}
                                                <img 
                                                    src={member.src} 
                                                    alt={member.name} 
                                                    className="w-full h-full object-cover object-center transition-transform duration-1000 group-hover:scale-105"
                                                />
                                                
                                                {/* Overlays */}
                                                <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-primary/20 to-transparent opacity-40 group-hover:opacity-90 transition-opacity duration-700" />
                                                
                                                {/* Content */}
                                                <div className="absolute inset-0 p-6 flex flex-col justify-end items-center text-center">
                                                    {/* Status Label on Photo - Always Visible */}
                                                    <div className="mb-3">
                                                        <span className="inline-block px-3 py-1.5 rounded-lg bg-accent/90 backdrop-blur-sm text-white text-[9px] font-black uppercase tracking-[0.15em] shadow-lg border border-white/10">
                                                            {member.status}
                                                        </span>
                                                    </div>
                                                    
                                                    {/* Name */}
                                                    <div className="flex flex-col items-center gap-1">
                                                        <h4 className="text-white font-serif text-lg leading-tight group-hover:text-accent transition-colors duration-300">
                                                            {member.name}
                                                        </h4>
                                                        <div className="h-0.5 w-12 bg-accent/50 scale-x-0 group-hover:scale-x-100 transition-all duration-500" />
                                                    </div>
                                                </div>

                                                {/* Discreet Status for non-hover state */}
                                                <div className="absolute top-4 right-4 group-hover:opacity-0 transition-opacity duration-300">
                                                    <div className="w-2 h-2 bg-accent rounded-full animate-pulse" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {category.id !== "support" && <div className="h-px w-full bg-gradient-to-r from-border via-border/20 to-transparent my-16" />}
                                </div>
                            ))}
                        </section>

                        {/* Section 2: Contact Box */}
                        <section id="contact" className="bg-primary text-white p-8 rounded-md relative overflow-hidden">
                            <div className="absolute top-0 right-0 w-32 h-32 bg-accent/10 rounded-full -mr-16 -mt-16" />
                            <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
                                <div>
                                    <h3 className="heading-3 mb-2">Besoin d'assistance ?</h3>
                                    <p className="text-sm text-white/80">Le Secrétariat Général est à votre disposition pour toute demande administrative.</p>
                                </div>
                                <Button className="bg-accent text-accent-foreground px-6 py-3 text-sm font-bold shadow-lg hover:bg-accent/90 transition-smooth rounded-md whitespace-nowrap">
                                    Contacter le Secrétariat
                                    <ArrowRight className="w-4 h-4 ml-2" />
                                </Button>
                            </div>
                        </section>

                    </main>
                </div>
            </article>
        </div>
    )
}
